import { DocumentType } from "api/generated";

export const formatDocumentType = (value: DocumentType) => {
  if (value === DocumentType.PRIVACY_POLICY) {
    return "Privacy Policy";
  } else if (value === DocumentType.TERMS_AND_CONDITIONS) {
    return "Terms And Conditions";
  } else return value;
};
